import { call, put } from "redux-saga/effects";
import {deleteKpiStateApi} from "../../../Connections/APIs/Plans"
import { keysToLowerCase } from "../../../Utils/formant";
import * as API from "../../../Connections/APIs/Plans";

import * as Action from "../../Actions/Plan/Actions";

export function* getPlansSaga(action) {
  try {
    const response = yield call(API.getPlansApi, action.query);
    yield put(Action.getPlansSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getPlansFailAction(error));
  }
}

export function* getAllPlansSaga(action) {
  try {
    const response = yield call(API.getPlansApi, action.query);
    yield put(Action.getAllPlansListSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getAllPlansListFailAction(error));
  }
}

export function* createPlanSaga(action) {
  try {
    const response = yield call(API.createPlanApi, action.plan);
    yield put(Action.createPlanSuccessAction(response.data));
  } catch (error) {
    yield put(Action.createPlanFailAction(error));
  }
}

export function* postPlanConfigSaga(action) {
  try {
    const response = yield call(API.postPlanConfigApi, action.config);
    yield put(Action.postPlanConfigSuccessAction(response.data));
  } catch (error) {
    yield put(Action.postPlanConfigFailAction(error));
  }
}

export function* getToolNameListSaga(action) {
  try {
    const response = yield call(API.getToolNameListApi, action.config);
    yield put(Action.getToolNameListSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getToolNameListFailAction(error));
  }
}

export function* updatePlanSaga(action) {
  try {
    const response = yield call(API.updatePlanApi, action.plan);
    yield put(Action.updatePlanSuccessAction(response.data));
  } catch (error) {
    yield put(Action.updatePlanFailAction(error));
  }
}

export function* restorePlanSaga(action) {
  try {
    const response = yield call(API.restorePlanApi, action.data);
    yield put(Action.restorePlanSuccessAction(response.data));
  } catch (error) {
    yield put(Action.restorePlanFailAction(error));
  }
}

export function* restoreDriverSaga(action) {
  try {
    const response = yield call(API.restoreDriverApi, action.data);
    yield put(Action.RestoreDriverSuccessAction(response.data));
  } catch (error) {
    yield put(Action.RestoreDriverFailAction(error));
  }
}

export function* executePlanSaga(action) {
  try {
    const response = yield call(API.executePlanApi, action.plan);
    yield put(Action.executePlanSuccessAction(response.data));
  } catch (error) {
    yield put(Action.executePlanFailAction(error));
  }
}

export function* MissionInfoByIdSaga(action) {
  try {
    const response = yield call(API.missionInfoByIdApi, action.data);
    yield put(Action.missionInfoByOrderIdSuccessAction(response.data));
  } catch (error) {
    yield put(Action.missionInfoByOrderIdFailAction(error));
  }
}

export function* getPlanIntegrationSaga(action) {
  try {
    const response = yield call(API.getPlanIntegrationApi, action.data);
    yield put(Action.GetPlanIntegratinSuccessAction(response.data));
  } catch (error) {
    yield put(Action.GetPlanIntegratinFailAction(error));
  }
}

export function* sendPlanIntegrationSaga(action) {
  try {
    const response = yield call(API.sendPlanIntegrationApi, action.data);
    yield put(Action.sendPlanIntegrationSuccessAction(response.data));
  } catch (error) {
    yield put(Action.sendPlanIntegrationFailAction(error));
  }
}

export function* errorPlanMessageSaga(action) {
  try {
    const response = yield call(API.errorPlanMessageApi, action.id);
    yield put(Action.errorPlanMessageSuccessAction(response.data));
  } catch (error) {
    yield put(Action.errorPlanMessageFailAction(error));
  }
}

export function* deletePlanSaga(action) {
  try {
    const response = yield call(API.deletePlanApi, action.id);
    yield put(Action.deletePlanSuccessAction(response.data));
  } catch (error) {
    yield put(Action.deletePlanFailAction(error));
  }
}

export function* downloadOptimizeFileSaga(action) {
  try {
    const response = yield call(API.DownloadResultOptimzeFileApi, action.plan);
    yield put(
      Action.downloadOptimizeFileSuccessAction(keysToLowerCase(response.data))
    );
  } catch (error) {
    yield put(Action.downloadOptimizeFileFailAction(error));
  }
}

export function* downloadExcelFileSaga(action) {
  try {
    const response = yield call(API.DownloadExcelFileApi, action.plan);
    yield put(
      Action.downloadExcelFileSuccessAction(keysToLowerCase(response.data))
    );
  } catch (error) {
    yield put(Action.downloadExcelFileFailAction(error));
  }
}

export function* downloadPlanFormSaga(action) {
  try {
    const response = yield call(API.downloadPlanFormApi, action.plan);
    yield put(
      Action.downloadPlanFormSuccessAction(keysToLowerCase(response.data))
    );
  } catch (error) {
    yield put(Action.downloadPlanFormFailAction(error));
  }
}

export function* getFromExternalSourceSaga(action) {
  try {
    const response = yield call(API.getFromExternalSourceApi, action.data);
    yield put(
      Action.getFromExternalSourceSuccessAction(
        response.data,
        `${action.data.dateFrom} - ${action.data.dateTo}`
      )
    );
  } catch (error) {
    yield put(Action.getFromExternalSourceFailAction(error));
  }
}

export function* getPlanLogsSaga(action) {
  try {
    const response = yield call(API.getPlanLogsApi, action.data);
    yield put(
      Action.getPlanLogsSuccessAction(
        response.data,
        `${action.data.dateFrom} - ${action.data.dateTo}`
      )
    );
  } catch (error) {
    yield put(Action.getPlanLogsFailAction(error));
  }
}

export function* deleteKpiStateSaga(action) {
  try {
    const response = yield call(API.deleteKpiStateApi, action.data);
    yield put(
        Action.deleteKpiStateSuccessAction(keysToLowerCase(response.data))
    );
  } catch (error) {
    yield put(Action.deleteKpiStateFailAction(error));
  }
}